# frozen_string_literal: true

module Engine
  module Game
    module G1850Jr
    end
  end
end
